// Translations
import {
  APP_LOADING_DESCRIPTION,
  APP_LOADING_TITLE,
} from '../translations/app-information.translations';

const APP_INFORMATION_PROVIDER_LOADING_PROPS = {
  description: APP_LOADING_DESCRIPTION,
  title: APP_LOADING_TITLE,
};

export { APP_INFORMATION_PROVIDER_LOADING_PROPS };
